/**
 * Store admin — edit collection (Commerce, M6).
 * @see prototype/store/admin/all.html#collections-edit
 */
import { createFileRoute } from "@tanstack/react-router";
import { CollectionEditPage } from "../../../../../../features/store/collections/collection-edit-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/collections/$collectionId/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { collectionId } = Route.useParams();
  return <CollectionEditPage collectionId={collectionId} />;
}
